import 'slick-carousel';
import _ from 'lodash';

(function($) {
  _.each($('.card-grid-feat__slider-slides'), slider => {
    const $slider = $(slider);

    $slider.slick({
      arrows: false,
      slidesToShow: 2,
    });

    const $slides = $slider.find('.slick-slide');

    $(window).on(
      'resize',
      _.throttle(() => setSlideHeights($slider, $slides), 200),
    );

    setSlideHeights($slider, $slides);
  });

  function setSlideHeights(slider, slides) {
    _.each(slides, slide => {
      $(slide).css({ height: '' });
    });
    let tallest = 0;
    _.each($(slider).find('.card-grid-feat__card'), slide => {
      const height = $(slide).outerHeight(true);
      if (height > tallest) {
        tallest = height;
      }
    });
    _.each(slides, slide => {
      $(slide).css({ height: tallest });
    });
  }
})(jQuery);
